import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { PropertyProvider } from './context/PropertyContext';
import { loadSavedTheme } from './utils/themeLoader';
import { initAllScrollFixes } from './utils/smoothScroll';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Admin from './pages/Admin';
import './App.css';

function App() {
  // Load saved theme and initialize smooth scrolling on app startup
  useEffect(() => {
    loadSavedTheme();
    initAllScrollFixes();
  }, []);

  return (
    <ErrorBoundary>
      <PropertyProvider>
        <Router>
          <div className="App">
            <Toaster 
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#1a1a1a',
                  color: '#fff',
                  fontFamily: 'Inter, sans-serif',
                },
                success: {
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </div>
        </Router>
      </PropertyProvider>
    </ErrorBoundary>
  );
}

export default App;